// Module singleton tracking the conversation currently OPEN on screen (its
// local hex id), so the notification service can suppress a banner for the
// chat the user is already looking at. Published by ChatRouteHost whenever
// the selection changes; read synchronously by the notification deps.

let activeConversationId: string | null = null;

export function setActiveNotificationConversation(id: string | null): void {
  activeConversationId = id;
}

export function getActiveNotificationConversation(): string | null {
  return activeConversationId;
}
